import { connect } from 'react-redux';
import { othersHaveCommentedSelector } from '../../selectors';
import { openReplyForm, clearUpdatedComment } from '../../../actions';
import { deleteAnswer } from '../../../../../data/answers';
import AnswerView from './container';
import { showModal } from '../../../../../services/sharedUIActions';

const mapStateToProps = (state, {
    id,
}) => ({
    othersHaveCommented: othersHaveCommentedSelector(state, id),
});

export default connect(mapStateToProps, {
    openReplyForm,
    showModal,
    deleteAnswer,
    clearUpdatedComment,
})(AnswerView);
